/**
 * Two-state segmented toggle that switches between server-rendered view
 * variants (e.g. cards vs list). Persists the choice in a session cookie
 * (no expiry — cleared when the browser closes) so the controller can
 * read it on the next request.
 */
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    cookieName: String,
    current: String,
  };

  select(event) {
    const view = event.params.view;
    if (!view) return;

    this.writeCookie(view);

    if (view === this.currentValue) return;

    Turbo.visit(window.location.href, { action: "replace" });
  }

  writeCookie(value) {
    if (!this.cookieNameValue) return;
    const encoded = encodeURIComponent(value);
    document.cookie = `${this.cookieNameValue}=${encoded}; path=/; SameSite=Lax`;
  }
}
